import { boot } from "quasar/wrappers";
import { routeManager } from "src/router/RouteManager";
import { auth } from "~/core/Auth";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
export default boot(async ({ app, router }) => {
    await auth.init();
    await commonStore.init();
    myPageStore.load();
    routeManager.initRoute(router);
    app.config.globalProperties.$auth = auth;
});
